<template>
   <div class="asset-meta-data">
      <div v-if="metadata.filename != '' && metadata.filename != undefined" class="info-container"><div class="label">File name:</div><div class="entry">{{metadata.filename}}</div></div>
      <div v-else-if="metadata.title != '' && metadata.title != undefined" class="info-container"><div class="label">Name:</div><div class="entry">{{metadata.title}}</div></div>
      <div v-if="metadata.description != '' && metadata.description != undefined" class="info-container"><div class="label">Description:</div><div class="entry">{{metadata.description}}</div></div>
      <div v-if="metadata.contributor != '' && metadata.contributor != undefined" class="info-container"><div class="label">Contributor: </div><div class="entry">{{metadata.contributor}}</div></div>
      <div v-if="metadata.upload_date != '' && metadata.upload_date != undefined" class="info-container"><div class="label">Upload Date: </div><div class="entry">{{createDateStr(metadata.upload_date)}}</div></div>
      <div v-if="currSelectedAssetType != 10 && metadata.duration != '' && metadata.duration != undefined" class="info-container"><div class="label">Runtime:</div><div class="entry">{{metadata.duration}}</div></div>
      <div v-if="currSelectedAssetType != 10 && currSelectedAssetType != 6 && metadata.dimensions != '' && metadata.dimensions != undefined" class="info-container"><div class="label">Dimension:</div><div class="entry">{{metadata.dimensions}}</div></div>
      <div v-if="currSelectedAssetType != 10 && currSelectedAssetType != 6 && metadata.file_size != '' && metadata.file_size != undefined" class="info-container"><div class="label">Filesize: </div><div class="entry">{{metadata.file_size}}</div></div>
      <div v-if="currSelectedAssetType != 10" class="info-container">
         <div class="label">Templates:</div>
         <div v-if="templates.length == 0">None</div>
         <div v-else v-for="template in templates" :key="template" class="entry">{{template}}</div></div>
      <div v-if="currSelectedAssetType != 10" class="info-container">
         <div class="label">Usage: </div>
         <div class="entry">
            <div>{{metadata.active ? 'Active' : 'Inactive'}}</div>
            <!-- <div>Channels: {{metadata.channels.length}}</div> -->
            <div>Instances: {{instancesNum}}</div>
         </div>
      </div>
   </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {

   data() {
      return {
         metadata: {},
         instancesNum: 0,
         templates: []
      }
   },

   props: {
      assetRecid: '',
   },

   computed: {
      ...mapState('global', [
         'currSelectedAssetType'
      ])
   },

   created() {
      let self = this;
      $.post(
         this.BARD_HOST + '/media/meta/' + this.assetRecid,
         {
            'token'      : localStorage.getItem('token'),
            'origin'     : this.currSelectedAssetType == 6 || this.currSelectedAssetType == 10 ? 1 : 0,
            'assetType'  : this.currSelectedAssetType
         }, function(data) {
            if (!data.error) {
               self.metadata = data;
               self.instancesNum = data.instances;
               self.templates = data.templates;
            } else {
               self.handleFailedAPICall('/' + this.getAssetString(this.currSelectedAssetType) + '/meta/' + this.assetRecid, 'MPMetaData', data);
            }
         }
      );
   },

   methods: {
      getAssetString(currSelectedAssetType) {
         let assetStr;
         switch(currSelectedAssetType) {
            case 1: 
               assetStr = 'image';
               break;
            case 2:
               assetStr = 'movie';
               break;
            case 3:
               assetStr = 'audio';
               break;
            case 6:
               assetStr = 'feeds';
               break;
            default:
               assetStr = 'image';
               break;
         }
         return assetStr;
      },

      createDateStr(date) {
         let d = new Date(date + ' UTC');
         return d.toLocaleDateString("en-US", { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' });
      }
   }
}
</script>

<style lang="scss" scoped>

.asset-meta-data {
   background-color: inherit;
   text-align: left; 

   .info-container {
      min-height: 35px;
   }

   .info-container:not(:first-child) {
      margin-top: 5px;
   }

   .label {
      font-size: .65rem;
      text-transform: uppercase;
      color: gray;
      margin-bottom: -5px;
   }

   .entry {
      font-size: .875rem;
      line-height: 16px;
      color: black;
      overflow: hidden;
      word-break: initial;
   }

   &::first-line {
      margin-top: 0px;
   }

   .info-container:first-of-type {
      .entry {
         overflow: hidden;
         word-break: break-all;
      }
   }
}
</style>